/**
 * Banks a customer's statement can come from, with their CBN codes. The backend sends the code to the statement
 * analysis (Indicina) with the PDF. Bundled because the gateway has no public bank list; keep it in step with the
 * banks Indicina supports.
 */
export interface Bank {
  bankName: string;
  bankCode: string;
}

export const BANKS: Bank[] = [
  { bankName: 'Access Bank', bankCode: '044' },
  { bankName: 'Access Bank (Diamond)', bankCode: '063' },
  { bankName: 'Citibank Nigeria', bankCode: '023' },
  { bankName: 'Ecobank Nigeria', bankCode: '050' },
  { bankName: 'Fidelity Bank', bankCode: '070' },
  { bankName: 'First Bank of Nigeria', bankCode: '011' },
  { bankName: 'First City Monument Bank (FCMB)', bankCode: '214' },
  { bankName: 'Globus Bank', bankCode: '00103' },
  { bankName: 'Guaranty Trust Bank (GTBank)', bankCode: '058' },
  { bankName: 'Heritage Bank', bankCode: '030' },
  { bankName: 'Jaiz Bank', bankCode: '301' },
  { bankName: 'Keystone Bank', bankCode: '082' },
  { bankName: 'Kuda Microfinance Bank', bankCode: '50211' },
  { bankName: 'Lotus Bank', bankCode: '303' },
  { bankName: 'Moniepoint Microfinance Bank', bankCode: '50515' },
  { bankName: 'OPay', bankCode: '999992' },
  { bankName: 'PalmPay', bankCode: '999991' },
  { bankName: 'Parallex Bank', bankCode: '104' },
  { bankName: 'Polaris Bank', bankCode: '076' },
  { bankName: 'Premium Trust Bank', bankCode: '105' },
  { bankName: 'Providus Bank', bankCode: '101' },
  { bankName: 'Stanbic IBTC Bank', bankCode: '221' },
  { bankName: 'Standard Chartered Bank', bankCode: '068' },
  { bankName: 'Sterling Bank', bankCode: '232' },
  { bankName: 'SunTrust Bank', bankCode: '100' },
  { bankName: 'Titan Trust Bank', bankCode: '102' },
  { bankName: 'Union Bank of Nigeria', bankCode: '032' },
  { bankName: 'United Bank for Africa (UBA)', bankCode: '033' },
  { bankName: 'Unity Bank', bankCode: '215' },
  { bankName: 'VFD Microfinance Bank', bankCode: '566' },
  { bankName: 'Wema Bank', bankCode: '035' },
  { bankName: 'Zenith Bank', bankCode: '057' },
];
